import Swiper, { Autoplay } from 'swiper';

Swiper.use([Autoplay]);

if (document.querySelector('[data-announcement-slider]')) {
    // Wait for DOM to be fully ready
    document.addEventListener('DOMContentLoaded', () => {
        // eslint-disable-next-line no-unused-vars
        const slider = new Swiper('[data-announcement-slider]', {
            speed: 300,
            allowTouchMove: false,
            preventClicks: false,
            preventClicksPropagation: false,
            slideToClickedSlide: false,
            slidesPerView: 'auto',
            centeredSlides: true,
            watchSlidesProgress: true, // Monitor slide progress for better interaction
            touchRatio: 0.2, // Reduce touch sensitivity to prioritize link clicks
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            breakpoints: {
                700: {
                    speed: 1000,
                },
            },
            on: {
                init: function() {
                    // Make sure all links in slides are clickable after initialization
                    const sliderLinks = document.querySelectorAll('[data-announcement-slider] a');
                    sliderLinks.forEach(link => {
                        link.addEventListener('click', (e) => {
                            e.stopPropagation(); // Prevent event from bubbling to swiper
                        });
                    });
                }
            }
        });
    });
}
